export const iconFontAwesomeMusicVideoVolumeOff = (
	<i className="fa-solid fa-volume-off"></i>
);
